import { render, staticRenderFns } from "./servicesum.vue?vue&type=template&id=2cbfdcf3&scoped=true&"
import script from "./servicesum.vue?vue&type=script&lang=js&"
export * from "./servicesum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbfdcf3",
  null
  
)

export default component.exports